import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from './data.service';

@Injectable({ providedIn: 'root' })
export class CustomAnalyticsService {
  constructor(private dataService: DataService, private activatedRoute: ActivatedRoute) {}

  public init(): void {

  }

  public sendEvent(eventName: string, data: any) {
    const userUUID = this.getUserId();
    const requestData = {
      client_id: userUUID,
      fp: this.getFingerPrint(),
      event_name: eventName,
      r: document.referrer,
      q: this.getUrlParams(),
      data
    };

    this.dataService.sendCustomAnalyticsEvent(requestData).subscribe(() => {});
  }

  private getUserId(): string {
    let userId = localStorage.getItem('customAnalyticsUserId');

    if (!userId) {
      userId = this.createUserId();
    }

    return userId;
  }

  private createUserId(): string {
    const userId = self.crypto['randomUUID']();

    localStorage.setItem('customAnalyticsUserId', userId);

    return userId;
  }

  private getFingerPrint(): any {
    return {
      userAgent: navigator.userAgent || null,
      platform: navigator.platform || null,
      vendor: navigator.vendor || null,
      language: navigator.language || null,
      languages: (navigator.languages && navigator.languages.slice(0, 5)) || null,
      screen: {
        width: screen.width,
        height: screen.height,
        availWidth: screen.availWidth,
        availHeight: screen.availHeight,
        colorDepth: screen.colorDepth,
        pixelRatio: window.devicePixelRatio || 1
      },
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
      hardwareConcurrency: navigator.hardwareConcurrency || null,
      deviceMemory: navigator['deviceMemory'] || null,
      maxTouchPoints: navigator.maxTouchPoints || 0,
      cookieEnabled: navigator.cookieEnabled
    };
  }

  private getUrlParams(): any {
    return this.activatedRoute.snapshot.queryParams;
  }
}
